export default "__VITE_ASSET__C03vjwjk__"